import { render, staticRenderFns } from "./OnDemand.vue?vue&type=template&id=5903434c&scoped=true&"
import script from "./OnDemand.vue?vue&type=script&lang=js&"
export * from "./OnDemand.vue?vue&type=script&lang=js&"
import style0 from "./OnDemand.vue?vue&type=style&index=0&id=5903434c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5903434c",
  null
  
)

export default component.exports